import React, { FC } from "react"
import L10n from "lib/carrot-l10n"
import { Body, H2, FlexContainer, Stack } from "@carrotfertility/carotene"
import { Steps } from "../workflow/steps"
import { useStateMachine } from "../../context/stateMachine/StateMachineContext"
import { useProgressTracker } from "../../views/modal/ProgressTracker"
import { IlloCalendar } from "../../views/atoms/Illustrations"
import { BenefitEnrollmentModalContinueButton } from "../shared"
import { useBenefitEnrollment } from "../../context/enrollment/BenefitEnrollmentContext"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const ViewName = Steps.RE_ENROLL_INTRO_NOTE

const ReEnrollIntroNote: FC = () => {
  const { needsBenefitEnrollment } = useBenefitEnrollment()
  const { setNextStep } = useStateMachine(ViewName, null)

  const { hideProgress } = useProgressTracker()
  hideProgress()

  return (
    <>
      <Stack spacing="medium">
        <FlexContainer justifyContent="center" padding="none">
          <IlloCalendar height={228} width={228} />
        </FlexContainer>
        <H2 variant="primary" stack="tiny">{l`Note:`}</H2>
      </Stack>
      <Stack spacing="medium">
        <Body color="black-80">
          {l`The accuracy of your answers may have legal and financial implications, so if there's something you're not sure about, 
          please check with your insurance provider, benefits portal, and/or HR department.`}
        </Body>
        <BenefitEnrollmentModalContinueButton
          onClick={() => setNextStep(ViewName, needsBenefitEnrollment ? "" : "SKIP_THIS_FLOW")}
        />
      </Stack>
    </>
  )
}

export { ReEnrollIntroNote }
